const config = {
  REACT_APP_URL: import.meta.env.REACT_APP_URL,
  SHOP_URL: import.meta.env.REACT_APP_SHOP_URL,
  API_BASE_URL: import.meta.env.REACT_APP_API_BASE_URL,
  CONTACT_BASE_URL: import.meta.env.REACT_APP_CONTACT_BASE_URL,
  S3_BUCKET: import.meta.env.REACT_APP_S3_BUCKET,
};

export default config;
